import { StaffAuthService } from 'app/shared/services/staff-auth.service';
import { RoofPurcharseConfig } from './../../interfaces/mechanic/ocr-model';
import { PurcharseDetail } from './../../interfaces/mechanic/invoice-detail';
import { ListPurchaseService } from './../../../list-purchase/share/service/list-purchase.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'invoice-confirm',
  templateUrl: './invoice-confirm.component.html',
  styleUrls: ['./invoice-confirm.component.scss'],
})
export class InvoiceConfirmComponent implements OnInit {


  @Input()
  public invoiceId: string;
  @Output()
  public cancelEvent = new EventEmitter();
  @Output()
  public confirmEvent = new EventEmitter<string>();
  
  public listPurcharse: PurcharseDetail[];
  public listBanker: PurcharseDetail[];
  public note: string;
  public roofPurcharseConfig: RoofPurcharseConfig = new RoofPurcharseConfig();
  constructor(private listPurchaseService: ListPurchaseService, private staffService: StaffAuthService) {

  }
  async ngOnInit() {
    if(this.invoiceId)
    {
      const invoiceDetails = await this.listPurchaseService.getInvoiceDetail(this.invoiceId).toPromise();
      if(invoiceDetails && invoiceDetails.listPurcharse)
      {
        this.note = invoiceDetails.note;
        this.listPurcharse = invoiceDetails.listPurcharse.filter(f => !f.extraSku);
        this.listBanker = invoiceDetails.listPurcharse.filter(f => f.extraSku);
      }
    }

    if (this.staffService.currentCampaignConfig && this.staffService.currentCampaignConfig.roofPurcharseConfig)
    {
      this.roofPurcharseConfig = this.staffService.currentCampaignConfig.roofPurcharseConfig;
    }
  }

  public onCancel(): void
  {
    this.cancelEvent.emit();
  }

  public onConfirm() : void
  {
    this.confirmEvent.emit(this.note);
  }
}
